import React, { useContext, useEffect } from "react";
//import "./safetyforms/safetyforms.css";
import { useForm } from "react-hook-form";
import { FaFolder, FaTimes } from "react-icons/fa";
import { useDispatch } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { newDocument } from "../common/slices/document";
import { BlackButton, ButtonBase, LightButton } from "./Buttons";
import FormDropZone from "./FormDropZone";
import FormTextArea from "./FormTextArea";
import FormTextInput from "./FormTextInput";
import Modal from "./Modal";
import Row from "./Row";
import { H1, P2 } from "./Typography";
import FormCheckbox from "./FormCheckbox";
import { ErrorContext } from "../ErrorContext";

const ModalUploadDocument = ({ onClose, folderId }) => {
    const errorContext = useContext(ErrorContext);
    const dispatch = useDispatch();
    const {
        control,
        handleSubmit,
        formState: { errors, isValid, isSubmitting },
        watch,
        setValue,
    } = useForm({
        defaultValues: {
            id: uuid(),
            folderId,
            name: "",
            summary: "",
        }
    });

    const formProps = { control, errors };

    const onSubmit = async (data) => {
        try {
            await dispatch(newDocument(data));
            onClose();
        } catch (ex) {
            errorContext.setError({ errorMessage: "Failed to create document", forSupport: ex.message });
        }
    };

    const pdfKey = watch('pdfKey');
    const fillable = watch('fillable');

    useEffect(() => {
        if (pdfKey) {
            setValue('name', pdfKey.split('.pdf')[0])
        }
    }, [pdfKey])

    return (
        <Modal show size="33%">
            <Row>
                <H1>Upload Document</H1>
                <ButtonBase onClick={onClose} style={{ marginLeft: 'auto' }}><FaTimes size='16px' color="#000" /></ButtonBase>
            </Row>
            <FormDropZone name="pdfKey" {...formProps} rules={{ required: true }} />

            {
                pdfKey &&
                <div>
                    <Row>
                        <FormTextInput name="name" label="Name" placeholder="Enter form name" {...formProps} rules={{ required: true }} containerStyle={{ flex: 1 }} />
                        {fillable && <FormTextInput {...formProps} name="daysUntilFinalized" label="Days Until Finalized" placeholder="Enter number of days (0-14)" rules={{ required: true, pattern: /^(1[0-4]|[0-9])$/i }} />}
                        <FormCheckbox name="fillable" label="Fillable" {...formProps} containerStyle={{ flex: 0 }} />
                    </Row>
                    {/* <div>
                        <P2>Location</P2>
                        <LightButton style={{ justifyContent: 'flex-start' }} onClick={() => { }}>
                            <FaFolder />
                            {document?.folder?.name}
                        </LightButton>
                    </div> */}
                    <FormTextArea name="summary" label="Summary" placeholder="Enter description" {...formProps} rows="7" />
                </div>
            }
            <BlackButton onClick={handleSubmit(onSubmit)} disabled={!isValid || isSubmitting}>Save</BlackButton>
        </Modal>
    );
};

export default ModalUploadDocument;
